export const renderStatus = (status) => {
  switch (status) {
    case 1:
      return (
        <div
          style={{
            fontWeight: 700,
            textAlign: 'center',
            borderRadius: '10px',
            fontSize: '12px',
            padding: '5px',
            minWidth: '100px',
            background: '#FFCB12',
            color: '#fff',
          }}
        >
          در حال بررسی
        </div>
      );

    case 2:
      return (
        <div
          style={{
            fontWeight: 700,
            textAlign: 'center',
            borderRadius: '10px',
            fontSize: '12px',
            padding: '5px 10px',
            minWidth: '100px',
            background: '#1FB23F',
            color: '#fff',
          }}
        >
          تایید شده
        </div>
      );

    case 3:
      return (
        <div
          style={{
            fontWeight: 700,
            textAlign: 'center',
            borderRadius: '10px',
            fontSize: '12px',
            padding: '5px 10px',
            minWidth: '100px',
            background: '#0029FF',
            color: '#fff',
          }}
        >
          درحال برگزاری
        </div>
      );

    case 4:
      return (
        <div
          style={{
            fontWeight: 700,
            textAlign: 'center',
            borderRadius: '10px',
            fontSize: '12px',
            padding: '5px 10px',
            minWidth: '100px',
            background: '#989898',
            color: '#fff',
          }}
        >
          برگزار شده
        </div>
      );

    case 6:
      return (
        <div
          style={{
            fontWeight: 700,
            textAlign: 'center',
            borderRadius: '10px',
            fontSize: '12px',
            padding: '5px 10px',
            minWidth: '100px',
            background: '#E50450',
            color: '#fff',
          }}
        >
          رد شده
        </div>
      );

    case 7:
      return (
        <div
          style={{
            fontWeight: 700,
            textAlign: 'center',
            borderRadius: '10px',
            fontSize: '12px',
            padding: '5px 10px',
            minWidth: '100px',
            background: '#FFCB12',
            color: '#fff',
          }}
        >
          برگزار نشد
        </div>
      );

    case 'STOPPED':
      return (
        <div
          style={{
            fontWeight: 700,
            textAlign: 'center',
            borderRadius: '10px',
            fontSize: '12px',
            padding: '5px 10px',
            minWidth: '100px',
            background: '#E50450',
            color: '#fff',
          }}
        >
          متوقف شده
        </div>
      );
    default:
      return '---';
  }
};
